exports = module.exports = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".account-icon[data-v-2b5ce3b2] {\n  border-radius: 50%;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n}\n.account-icon img[data-v-2b5ce3b2] {\n    width: 100%;\n    object-fit: cover;\n}\n", ""]);
